import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-maryland-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./maryland-state-form.component.html",
  styleUrl: "./maryland-state-form.component.scss",
})
export class MarylandStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
